import { PointerSensor } from '@dnd-kit/core';

// ── Custom sensor: skip drag activation on interactive elements ───────────────
// Cells contain form controls (selects, switches, color inputs) in their hover
// toolbars and config popovers; starting a drag from those would make them
// unusable.

const INTERACTIVE_TAGS = new Set([
  'input',
  'textarea',
  'select',
  'option',
  'button',
  'a',
]);

function isInteractive(el: EventTarget | null): boolean {
  if (!(el instanceof Element)) return false;
  if (INTERACTIVE_TAGS.has(el.tagName.toLowerCase())) return true;
  const parent = el.parentElement;
  return parent !== null && isInteractive(parent);
}

export class CanvasDragSensor extends PointerSensor {
  static activators = [
    {
      eventName: 'onPointerDown' as const,
      handler: ({ nativeEvent }: React.PointerEvent) => {
        if (nativeEvent.button !== 0) return false;
        return !isInteractive(nativeEvent.target);
      },
    },
  ];
}
